import { Badge } from '@mage-ui/components';
import { cx } from '@mage-ui/styled-system/css';
import {
  focus,
  languageCourseDisplay,
  title,
} from '@mage-ui/styled-system/recipes';
import Link from 'next/link';

export const LanguageCourseDisplay = ({ data, ...props }) => {
  return (
    <Link
      href={data.nice_url || '#'}
      className={cx(languageCourseDisplay().root, focus(), 'group')}
      {...(!data.nice_url && { 'aria-disabled': true })}
      {...props}
    >
      <abbr
        title={data.name}
        className={cx(
          title({ size: '1', weight: 'bold' }),
          languageCourseDisplay().title,
        )}
      >
        {data.iso}
      </abbr>
      {data.name && (
        <Badge aria-hidden='true' className={languageCourseDisplay().label}>
          {data.name}
        </Badge>
      )}
    </Link>
  );
};
